var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPlutonicSmallName = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 21,
    viewBox: "0 0 115 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.3896 2.31903C63.7598 2.31903 59.9689 6.15331 59.9689 10.9066C59.9689 15.6598 63.7287 19.4941 68.3896 19.4941C73.0194 19.4941 76.8103 15.6598 76.8103 10.9066C76.8103 6.15331 73.0194 2.31903 68.3896 2.31903ZM68.3896 16.2619C65.4998 16.2619 63.1383 13.8536 63.1383 10.9066C63.1383 7.95955 65.4998 5.55125 68.3896 5.55125C71.2794 5.55125 73.6409 7.95955 73.6409 10.9066C73.6409 13.8853 71.2794 16.2619 68.3896 16.2619Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M110.681 5.55125H115V2.31903H110.681C106.051 2.31903 102.26 6.15331 102.26 10.9066C102.26 15.6598 106.02 19.4941 110.681 19.4941H115V16.2619H110.681C107.791 16.2619 105.43 13.8536 105.43 10.9066C105.43 7.95955 107.791 5.55125 110.681 5.55125Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0719 13.0266C42.0719 14.8011 40.6426 16.2588 38.9025 16.2588C37.1624 16.2588 35.7331 14.8011 35.7331 13.0266V2.12582H32.5637V13.0266C32.5637 16.5757 35.3913 19.4593 38.8714 19.4593C42.3516 19.4593 45.1792 16.5757 45.1792 13.0266V2.12582H42.0098V13.0266H42.0719Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3205 2.66241C82.8403 2.66241 80.0127 5.54607 80.0127 9.09516V19.9959H83.1821V9.09516C83.1821 7.32062 84.6115 5.86295 86.3515 5.86295C88.0916 5.86295 89.5209 7.32062 89.5209 9.09516V19.9959H92.6903V9.09516C92.6593 5.54607 89.8006 2.66241 86.3205 2.66241Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0581 1.77417H95.8887V19.995H99.0581V1.77417Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M48.662 5.55125H51.8003V20.0011H54.9697V5.55125H58.108V2.31903H48.662V5.55125Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6451 13.0235V1.77417H20.4756V13.0235C20.4756 16.5726 23.3033 19.4563 26.7834 19.4563H28.8342V16.2557H26.7834C25.0744 16.2557 23.6451 14.7981 23.6451 13.0235Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9822 0.193176C4.35237 0.193176 0.561508 4.02748 0.561508 8.78075V20.0301H3.73091V15.467C5.16025 16.6395 6.99355 17.3683 8.9822 17.3683C13.612 17.3683 17.4029 13.534 17.4029 8.78075C17.4029 4.02748 13.6431 0.193176 8.9822 0.193176ZM8.9822 14.1361C6.09244 14.1361 3.73091 11.7278 3.73091 8.78075C3.73091 5.83372 6.09244 3.4254 8.9822 3.4254C11.872 3.4254 14.2335 5.83372 14.2335 8.78075C14.2646 11.7278 11.903 14.1361 8.9822 14.1361Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPlutonicSmallName);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/plutonicSmallName.208fec0f004fb6341cd05e513415e606.svg";